import { TMapOffersResult } from '../../../types/common/offer';
import { IOffersForShowOffers } from '../types';

export const getObjectForAnalyticsAboutShowingOffers = (offers: TMapOffersResult) => {
  const result = {} as IOffersForShowOffers;

  offers.forEach((offer, index) => {
    if (offer.type === 'personalized') {
      result[index] = {
        bank: 'all',
        isMultiOffer: false,
      };
    }
    if (offer.type === 'offer') {
      result[index] = {
        bank: offer.content.title.name,
        creditAmount: offer.content.conditions.limit,
        monthlyPayment: offer.content.conditions.monthlyPayment,
        interestRate: offer.content.conditions.rate?.rate,
        isMultiOffer: false,
      };
    } else if (offer.type === 'multi') {
      result[index] = {
        bank: offer.content[0].title.name,
        isMultiOffer: true,
      };
    }
  });

  return result;
};
